import { IQService, IPromise, Injectable } from "angular";
import {
  ChangeJournalObjectIdentifier,
  ChangeJournalObject,
  ChangeJournalViewItemResolver,
} from "../models";
import { RawParams } from "@uirouter/angularjs";

export const vsServiceName = "changeJournalViewItemService";
export const vsProviderName = `${vsServiceName}Provider`;

export type ChangeJournalViewItemServiceComponentConfigObject = {
  [objectName: string]: ChangeJournalViewItemServiceComponentConfig;
};

export interface ChangeJournalViewItemServiceComponentConfig {
  componentName: string;
  resolveObjects: Injectable<ChangeJournalViewItemResolver>;
  resolveInfoSref: (entry: ChangeJournalObject) => {
    sref: string;
    params: RawParams;
  };
}

export class ChangeJournalViewItemService {
  constructor(
    private readonly typeComponents: ChangeJournalViewItemServiceComponentConfigObject,
    private readonly $q: IQService,
    private readonly $injector: angular.auto.IInjectorService
  ) {}

  getConfigObject(objectName: string) {
    const key = objectName?.toLowerCase() ?? "unknown";
    return this.typeComponents[key];
  }

  getChangeObjectDetailSref(object: ChangeJournalObject) {
    const config = this.getConfigObject(object.id.ObjectName);
    return config.resolveInfoSref(object);
  }

  resolveObjects(
    id: ChangeJournalObjectIdentifier
  ): IPromise<ChangeJournalObject[]> {
    const config = this.getConfigObject(id.ObjectName);
    if (!config) {
      return this.$q.when([this.unknownType(id)]);
    }

    return this.$injector.invoke<IPromise<ChangeJournalObject[]>>(
      config.resolveObjects,
      undefined,
      { objectIdentifier: id, config }
    );
  }

  private unknownType(id: ChangeJournalObjectIdentifier): ChangeJournalObject {
    return {
      id,
      object: {
        Error: `Must register type ${id.ObjectName} with ${vsProviderName}`,
      },
    };
  }
}
